import client from "api/client";

import type { SearchApi } from "api/models/index";
import type { ProfileEdit, ProfileInfo } from "api/models/profile";
import type { UserDepositApi } from "api/models/user/pay";


const base = "/admin/profile";
const profile = {
	edit: (body: ProfileEdit) => client.post<ProfileInfo>(base + "/edit", body),
	deposits: (body: SearchApi<{ profileId: number }>) => client.post<UserDepositApi[]>(base + "/deposits", body, { paginated: true })
};

export default profile;